export const BASE_URL = 'https://myb-stylish-watches-server.onrender.com';